export default (theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    marginTop: theme.spacing(2),
  },
  progressWrapper: {
    paddingTop: '48px',
    paddingBottom: '24px',
    display: 'flex',
    justifyContent: 'center',
  },
  active: {
    backgroundColor: '#0080BC !important',
    color: theme.palette.common.white,
  },
  activeCorporate: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
  },
});
